/**
 * Lithofinder Decision Tree - Complete Knowledge Base
 * Client-side data for the Lithofinder (0 API costs)
 *
 * 4 surface groups · 16 subtypes · 14 problems · 130+ recommendations
 * Every recommendation includes products, method statement, and pro tips
 */
window.LithofinderData = {

  // Product name → article number (for Shopify product links + images)
  productMap: {
    // ── MN Line (Natural Stone) ──
    "Lithofin MN Power-Clean":          "160",
    "Lithofin MN Builders' Clean":      "162",
    "Lithofin MN Outdoor Cleaner":      "163",
    "Lithofin MN Basic Protection":     "165",
    "Lithofin MN Stain-Stop":           "166",
    "Lithofin MN Colour Intensifier":   "167",
    "Lithofin MN Polish Liquid":        "169",
    "Lithofin MN Care-Seal":            "170",
    "Lithofin MN Polish Cream":         "171",
    "Lithofin MN Wash & Clean":         "173",
    "Lithofin MN Slate-Oil":            "177",
    "Lithofin MN Easy-Clean":           "189",
    "Lithofin MN Concrete Coating":     "194",

    // ── KF Line (Ceramics & Tiles) ──
    "Lithofin KF Cement Residue Remover": "110",
    "Lithofin KF Ceramic-Clean":        "111",
    "Lithofin KF Mildew-Away":          "114",
    "Lithofin KF Grout Cleaner":        "115",
    "Lithofin KF Grout Protector":      "116",
    "Lithofin KF Clinker Oil":          "120",
    "Lithofin KF Intensive Cleaner":    "180",
    "Lithofin KF Conditioning Cleaner": "182",
    "Lithofin KF Protective Impregnator": "183",

    // ── Cotto/Terracotta Line ──
    "Lithofin TC Ever-Sheen":           "137",
    "Lithofin Cotto Easy-Clean":        "138",
    "Lithofin TC Sealant":              "139",
    "Lithofin TC Impregnator":          "140",
    "Lithofin TC Classic Primer":       "141",
    "Lithofin TC Classic Wax":          "144",

    // ── Universal / Special Products ──
    "Lithofin CEMENT-AWAY":             "010",
    "Lithofin WEXA":                    "012",
    "Lithofin WAX-OFF":                 "018",
    "Lithofin Anti-Slip":               "199",
    "Lithofin EASY-CARE":               "031",
    "Lithofin ALGEX":                   "032",
    "Lithofin Rust-EX":                 "038",
    "Lithofin OIL-EX":                  "187",
    "Lithofin Stainstop PLUS":          "188"
  },

  // Article number → Shopify product ID (numeric, permanent across all languages)
  // URL resolution happens via window.LithofinProductUrls (Liquid-generated, locale-aware)
  productIdMap: {
    "010": "15606901309772",
    "012": "15606900654412",
    "018": "15606901506380",
    "031": "15606900982092",
    "038": "15606901440844",
    "110": "15606899966284",
    "111": "15606899933516",
    "115": "15606900588876",
    "116": "15606900261196",
    "137": "15606902489420",
    "138": "15606902423884",
    "139": "15606902358348",
    "140": "15606902260044",
    "160": "15606898491724",
    "162": "15606898590028",
    "163": "15606898557260",
    "165": "15606898983244",
    "166": "15606898688332",
    "167": "15606899638604",
    "170": "15606898950476",
    "171": "15606899736908",
    "173": "15606899474764",
    "177": "15606898819404",
    "180": "15606899900748",
    "182": "15606900392268",
    "183": "15606900195660",
    "187": "15606901342540",
    "188": "15606900818252",
    "189": "15606899179852",
    "194": "15606898753868",
    "199": "15606901244236"
  },

  // ── Surface Types & Subtypes ──────────────────────────────────
  surfaceTypes: [
    {
      id: "natural-stone",
      subtypes: [
        { id: "marble" },
        { id: "granite" },
        { id: "limestone" },
        { id: "sandstone" },
        { id: "slate" },
        { id: "bluestone" },
        { id: "basalt" }
      ]
    },
    {
      id: "ceramics",
      subtypes: [
        { id: "porcelain" },
        { id: "ceramic" },
        { id: "glass-mosaic" }
      ]
    },
    {
      id: "artificial-stone",
      subtypes: [
        { id: "concrete" },
        { id: "quartz-composite" },
        { id: "terrazzo" }
      ]
    },
    {
      id: "cotto-terracotta",
      subtypes: [
        { id: "terracotta" },
        { id: "cotto" },
        { id: "clinker" }
      ]
    }
  ],

  // ── Available Problems per Surface Type ────────────────────────
  surfaceProblems: {
    "natural-stone": [
      "cement-residue", "general-cleaning", "oil-grease", "rust-stains",
      "efflorescence", "algae-moss", "limescale", "stain-protection",
      "color-enhancement", "daily-maintenance", "outdoor-cleaning",
      "mold-mildew", "anti-slip"
    ],
    "ceramics": [
      "cement-residue", "general-cleaning", "limescale", "oil-grease",
      "stain-protection", "daily-maintenance", "mold-mildew", "anti-slip"
    ],
    "artificial-stone": [
      "cement-residue", "general-cleaning", "oil-grease", "efflorescence",
      "algae-moss", "limescale", "stain-protection", "color-enhancement",
      "daily-maintenance", "outdoor-cleaning", "mold-mildew", "anti-slip"
    ],
    "cotto-terracotta": [
      "cement-residue", "general-cleaning", "wax-residue", "stain-protection",
      "color-enhancement", "daily-maintenance", "algae-moss", "outdoor-cleaning"
    ]
  },

  // ── Stone Properties (for info cards in wizard) ───────────────
  stoneProperties: {
    "marble":           { hardness: 3, porosity: "medium",    acidSensitive: true,  frostResistant: false, slipRisk: "medium" },
    "granite":          { hardness: 7, porosity: "low",       acidSensitive: false, frostResistant: true,  slipRisk: "low" },
    "limestone":        { hardness: 3, porosity: "high",      acidSensitive: true,  frostResistant: false, slipRisk: "medium" },
    "sandstone":        { hardness: 6, porosity: "very-high", acidSensitive: false, frostResistant: false, slipRisk: "low" },
    "slate":            { hardness: 5, porosity: "low",       acidSensitive: false, frostResistant: true,  slipRisk: "low" },
    "bluestone":        { hardness: 4, porosity: "low",       acidSensitive: true,  frostResistant: true,  slipRisk: "medium" },
    "basalt":           { hardness: 7, porosity: "low",       acidSensitive: false, frostResistant: true,  slipRisk: "low" },
    "porcelain":        { hardness: 7, porosity: "low",       acidSensitive: false, frostResistant: true,  slipRisk: "medium" },
    "ceramic":          { hardness: 5, porosity: "medium",    acidSensitive: false, frostResistant: false, slipRisk: "medium" },
    "glass-mosaic":     { hardness: 6, porosity: "low",       acidSensitive: false, frostResistant: true,  slipRisk: "high" },
    "concrete":         { hardness: 5, porosity: "high",      acidSensitive: false, frostResistant: false, slipRisk: "low" },
    "quartz-composite": { hardness: 7, porosity: "low",       acidSensitive: false, frostResistant: true,  slipRisk: "medium" },
    "terrazzo":         { hardness: 5, porosity: "medium",    acidSensitive: true,  frostResistant: false, slipRisk: "medium" },
    "terracotta":       { hardness: 3, porosity: "very-high", acidSensitive: false, frostResistant: false, slipRisk: "low" },
    "cotto":            { hardness: 3, porosity: "very-high", acidSensitive: false, frostResistant: false, slipRisk: "low" },
    "clinker":          { hardness: 6, porosity: "low",       acidSensitive: false, frostResistant: true,  slipRisk: "low" }
  },

  // ═══════════════════════════════════════════════════════════════
  // RECOMMENDATIONS - keyed by "surfaceId/subtypeId/problemId"
  // ═══════════════════════════════════════════════════════════════
  recommendations: {
    // ── Natural Stone ──────────────────────────────────────
    "natural-stone/basalt/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Apply undiluted or diluted 1:3. Leave 30-60 minutes. Scrub and rinse. Also works preventively.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "natural-stone/basalt/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply Anti-Slip evenly. Leave to act per instructions. Rinse thoroughly.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "natural-stone/basalt/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Apply undiluted or diluted 1:3. Leave 5-10 minutes. Scrub and rinse. Basalt is extremely acid-resistant.",
      tips: ["basalt_very_hard", "rinse_thoroughly"]
    },
    "natural-stone/basalt/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Apply thinly. Deepens the dark colour of basalt beautifully. Remove excess after 10-15 minutes.",
      tips: ["wet_look", "remove_excess"]
    },
    "natural-stone/basalt/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water for regular maintenance.",
      tips: ["warm_water"]
    },
    "natural-stone/basalt/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:3 with water. Pre-wet surface. Apply and leave 5-10 minutes. Scrub and rinse. Basalt is acid-resistant - safe concentration.",
      tips: ["basalt_very_hard", "rinse_thoroughly"]
    },
    "natural-stone/basalt/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:5 for regular cleaning. Apply, leave 5-10 minutes. Scrub with stiff brush and rinse.",
      tips: ["basalt_very_hard", "work_in_sections"]
    },
    "natural-stone/basalt/limescale": {
      products: ["Lithofin CEMENT-AWAY"],
      method: "Dilute 1:3 with water. Apply onto limescale deposits. Leave 5-10 minutes. Scrub and rinse thoroughly. Basalt handles acidic products well.",
      tips: ["basalt_very_hard", "rinse_thoroughly"]
    },
    "natural-stone/basalt/mold-mildew": {
      products: ["Lithofin ALGEX"],
      method: "Apply undiluted or diluted 1:3. Leave 15-30 minutes. Scrub and rinse. ALGEX also works against mold and mildew. Improve ventilation.",
      tips: ["improve_ventilation", "preventive_effect", "basalt_very_hard"]
    },
    "natural-stone/basalt/oil-grease": {
      products: ["Lithofin OIL-EX"],
      method: "Apply paste over stain. Cover with film. Leave 4-12 hours. Remove and clean with Power-Clean.",
      tips: ["poultice_method", "repeat_if_needed"]
    },
    "natural-stone/basalt/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:3 to 1:5. Apply with sprayer. Leave 15-30 minutes. Scrub and rinse with pressure washer.",
      tips: ["ideal_terrace", "outdoor_dry_weather"]
    },
    "natural-stone/basalt/rust-stains": {
      products: ["Lithofin Rust-EX"],
      method: "Apply undiluted onto the rust stain. Leave to act for 5-15 minutes. Rinse thoroughly. Basalt is extremely hard and acid-resistant, like granite.",
      tips: ["basalt_very_hard", "repeat_if_needed"]
    },
    "natural-stone/basalt/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin Stainstop PLUS", "Lithofin MN Care-Seal"],
      method: "Apply to clean, dry surface. Distribute evenly. Remove excess after 10-15 minutes. Allow 24 hours to cure.",
      tips: ["invisible_protection", "remove_excess"]
    },

    "natural-stone/bluestone/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3 with water. Spray onto affected areas. Leave 30-60 minutes. Scrub with brush and rinse. ALGEX is pH-neutral, safe for calcareous bluestone.",
      tips: ["preventive_effect", "outdoor_dry_weather", "bluestone_dilute"]
    },
    "natural-stone/bluestone/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply Anti-Slip evenly. Leave to act per instructions. Rinse thoroughly. Essential for bluestone kitchen floors and terraces.",
      tips: ["anti_slip_wet_areas", "test_first", "essential_countertop"]
    },
    "natural-stone/bluestone/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:5 to 1:10 - bluestone is calcareous! Pre-wet surface. Apply, leave 2-3 minutes max. Rinse thoroughly and immediately.",
      tips: ["bluestone_dilute", "dilute_calcareous", "pre_wet_porous"]
    },
    "natural-stone/bluestone/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Apply thinly to clean, dry surface. Brings out the characteristic blue-grey colour of bluestone. Remove excess after 10 minutes.",
      tips: ["wet_look", "remove_excess"]
    },
    "natural-stone/bluestone/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water. Mop regularly. pH-neutral - safe for daily use on calcareous bluestone.",
      tips: ["no_acid", "essential_countertop"]
    },
    "natural-stone/bluestone/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:10 with water (bluestone is calcareous!). Pre-wet surface. Apply carefully, leave maximum 2-3 minutes. Rinse immediately and thoroughly.",
      tips: ["bluestone_dilute", "rinse_thoroughly", "pre_wet_porous"]
    },
    "natural-stone/bluestone/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:5 to 1:10. Apply with mop, leave 5 minutes. Scrub and rinse. Avoid acidic cleaners!",
      tips: ["no_acid", "work_in_sections"]
    },
    "natural-stone/bluestone/limescale": {
      products: ["Lithofin MN Wash & Clean"],
      method: "Use at double concentration. Apply with soft cloth. Never use acidic descalers on bluestone - it's calcareous!",
      tips: ["no_acid", "bluestone_dilute"]
    },
    "natural-stone/bluestone/mold-mildew": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:3 with warm water. Apply and leave 10-15 minutes. Scrub with soft brush and rinse. Alkaline - safe for calcareous bluestone. Improve ventilation.",
      tips: ["improve_ventilation", "bluestone_dilute"]
    },
    "natural-stone/bluestone/oil-grease": {
      products: ["Lithofin OIL-EX"],
      method: "Apply paste thickly over stain. Cover with film. Leave 4-12 hours. Remove and clean with MN Wash & Clean.",
      tips: ["poultice_method", "essential_countertop"]
    },
    "natural-stone/bluestone/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:5. Apply, leave 15-30 minutes. Scrub with soft brush, rinse thoroughly. Ideal for bluestone terraces.",
      tips: ["ideal_terrace", "outdoor_dry_weather"]
    },
    "natural-stone/bluestone/rust-stains": {
      products: ["Lithofin Rust-EX"],
      method: "Apply undiluted onto the rust stain. Leave maximum 3-5 minutes - bluestone is calcareous! Rinse immediately and thoroughly. Pre-wet surrounding area.",
      tips: ["test_first", "bluestone_dilute", "rinse_thoroughly"]
    },
    "natural-stone/bluestone/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin MN Basic Protection", "Lithofin Stainstop PLUS", "Lithofin MN Care-Seal"],
      method: "Essential for bluestone countertops! Apply to clean, dry surface. Remove excess after 10-15 minutes. Allow 24 hours to cure.",
      tips: ["essential_countertop", "remove_excess", "allow_to_dry"]
    },

    "natural-stone/granite/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3 for light growth or use undiluted for heavy infestation. Apply with sprayer, leave 30-60 minutes, scrub and rinse. Works preventively.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "natural-stone/granite/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply evenly, leave to act per instructions. Rinse thoroughly. Invisible micro-texture reduces slip risk.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "natural-stone/granite/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Apply undiluted or diluted 1:3. Leave to act for 5-10 minutes until residue dissolves. Scrub and rinse thoroughly.",
      tips: ["granite_acid_resistant", "rinse_thoroughly"]
    },
    "natural-stone/granite/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Apply thinly to clean, dry surface. Wipe off excess after 10-15 minutes. Full colour develops within 24 hours.",
      tips: ["wet_look", "remove_excess"]
    },
    "natural-stone/granite/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin MN Easy-Clean", "Lithofin EASY-CARE"],
      method: "MN Wash & Clean: 2 capfuls per bucket of warm water, mop regularly. Easy-Clean: spray and wipe for quick daily cleaning.",
      tips: ["warm_water"]
    },
    "natural-stone/granite/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:3 with water. Pre-wet surface. Apply onto efflorescence and leave 5-10 minutes. Scrub and rinse. Granite is acid-resistant, so stronger concentrations are safe.",
      tips: ["granite_acid_resistant", "rinse_thoroughly"]
    },
    "natural-stone/granite/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:5 for regular cleaning or use undiluted for stubborn dirt. Apply, leave 5-10 minutes, scrub and rinse.",
      tips: ["work_in_sections", "leave_to_act"]
    },
    "natural-stone/granite/limescale": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:5. Apply, leave 3-5 minutes, scrub and rinse. Granite is acid-resistant so diluted acid cleaners are safe.",
      tips: ["granite_acid_resistant", "rinse_thoroughly"]
    },
    "natural-stone/granite/mold-mildew": {
      products: ["Lithofin ALGEX", "Lithofin MN Power-Clean"],
      method: "Apply ALGEX undiluted on mold spots. Leave 15-30 minutes. Scrub and rinse. For indoor areas, follow up with Power-Clean.",
      tips: ["improve_ventilation", "preventive_effect"]
    },
    "natural-stone/granite/oil-grease": {
      products: ["Lithofin OIL-EX", "Lithofin MN Power-Clean"],
      method: "For fresh stains: apply OIL-EX paste thickly, cover with film, leave 2-12 hours. For surface grease: use Power-Clean undiluted.",
      tips: ["poultice_method", "repeat_if_needed"]
    },
    "natural-stone/granite/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:3 to 1:5. Apply with sprayer or watering can. Leave 15-30 minutes. Scrub with stiff brush, rinse with pressure washer or garden hose.",
      tips: ["ideal_terrace", "outdoor_dry_weather"]
    },
    "natural-stone/granite/rust-stains": {
      products: ["Lithofin Rust-EX"],
      method: "Apply undiluted on the rust stain. Leave 5-15 minutes. Rinse well. Granite tolerates the product well due to its acid resistance.",
      tips: ["granite_acid_resistant", "repeat_if_needed"]
    },
    "natural-stone/granite/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin MN Basic Protection", "Lithofin Stainstop PLUS", "Lithofin MN Care-Seal"],
      method: "Apply to clean, dry surface. Distribute evenly, remove excess after 10-15 minutes. Allow 24 hours curing time.",
      tips: ["invisible_protection", "remove_excess", "allow_to_dry"]
    },

    "natural-stone/limestone/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3. Apply with sprayer, leave 30-60 minutes. Scrub with soft brush and rinse. Repeat for heavy growth.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "natural-stone/limestone/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply Anti-Slip evenly with a brush or roller. Leave to act as directed. Rinse thoroughly. Ideal for limestone floors in wet areas.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "natural-stone/limestone/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:10 minimum - limestone is highly calcareous! Pre-wet thoroughly. Apply carefully, leave only 1-2 minutes. Rinse immediately and thoroughly.",
      tips: ["dilute_calcareous", "pre_wet_porous", "test_first"]
    },
    "natural-stone/limestone/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Apply thinly to clean, dry surface. Limestone absorbs quickly - work in small sections. Remove excess after 10 minutes.",
      tips: ["wet_look", "work_in_sections", "test_first"]
    },
    "natural-stone/limestone/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin EASY-CARE", "Lithofin MN Polish Liquid"],
      method: "2 capfuls per bucket of warm water. Mop regularly. This pH-neutral cleaner is safe for daily use on calcareous stone.",
      tips: ["never_acid_limestone", "no_vinegar_marble"]
    },
    "natural-stone/limestone/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:10 minimum. Pre-wet surface. Apply carefully and briefly (1-2 minutes). Rinse immediately. Limestone is calcareous - minimal contact time!",
      tips: ["dilute_calcareous", "pre_wet_porous", "rinse_thoroughly"]
    },
    "natural-stone/limestone/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:10 for regular cleaning. Apply with mop, leave 5 minutes. Scrub gently and rinse. Never use acidic cleaners on limestone!",
      tips: ["never_acid_limestone", "work_in_sections"]
    },
    "natural-stone/limestone/limescale": {
      products: ["Lithofin MN Wash & Clean"],
      method: "Use at double concentration. Wipe firmly with a soft cloth. Never use acidic limescale removers - they will etch limestone instantly!",
      tips: ["never_acid_limestone", "no_vinegar_marble"]
    },
    "natural-stone/limestone/mold-mildew": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:3 with warm water. Apply generously and leave 10-15 minutes. Scrub with a soft brush and rinse well. Never use acidic mold removers on limestone. Improve ventilation to prevent recurrence.",
      tips: ["improve_ventilation", "never_acid_limestone"]
    },
    "natural-stone/limestone/oil-grease": {
      products: ["Lithofin OIL-EX"],
      method: "Apply OIL-EX paste thickly over the stain. Cover with cling film. Leave 4-12 hours for deep penetration. Remove and clean with MN Wash & Clean.",
      tips: ["poultice_method", "repeat_if_needed", "pre_wet_porous"]
    },
    "natural-stone/limestone/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:5 for limestone. Apply, leave 15-30 minutes. Scrub with soft brush (not wire!). Rinse thoroughly.",
      tips: ["ideal_terrace", "outdoor_dry_weather", "pre_wet_porous"]
    },
    "natural-stone/limestone/rust-stains": {
      products: ["Lithofin Rust-EX"],
      method: "Apply carefully on the stain only. Leave briefly (3-5 minutes max). Rinse extremely thoroughly. Limestone is sensitive - always test first!",
      tips: ["test_first", "never_acid_limestone", "rinse_thoroughly"]
    },
    "natural-stone/limestone/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin Stainstop PLUS", "Lithofin MN Care-Seal"],
      method: "Essential for limestone! Apply to clean, dry surface. Apply generously - limestone is very porous. Remove excess after 15 minutes. Allow 24 hours to cure.",
      tips: ["two_coats_porous", "sandstone_seal_essential", "allow_to_dry"]
    },

    "natural-stone/marble/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3 with water. Spray generously onto affected areas. Leave to act for 30-60 minutes. Scrub gently with a soft brush and rinse thoroughly. Apply preventively once a year.",
      tips: ["test_first", "preventive_effect", "outdoor_dry_weather"]
    },
    "natural-stone/marble/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply Anti-Slip evenly with a brush or roller. Leave to act as directed. Rinse thoroughly. Creates an invisible micro-texture.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "natural-stone/marble/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:5 with water. Pre-wet the surface. Apply with sponge, leave 2-3 minutes. Scrub lightly and rinse thoroughly. Important: marble is calcareous - always dilute and test first!",
      tips: ["test_first", "dilute_calcareous", "rinse_thoroughly"]
    },
    "natural-stone/marble/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Clean and dry the surface. Apply thinly and evenly with a cloth. Wipe off excess after 10-15 minutes. Allow 24 hours to develop full colour.",
      tips: ["wet_look", "test_first", "remove_excess"]
    },
    "natural-stone/marble/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin MN Easy-Clean", "Lithofin EASY-CARE", "Lithofin MN Polish Liquid", "Lithofin MN Polish Cream"],
      method: "MN Wash & Clean: add 2 capfuls to a bucket of warm water, mop as usual. MN Easy-Clean: spray directly and wipe - ideal for countertops.",
      tips: ["no_vinegar_marble", "never_acid_marble"]
    },
    "natural-stone/marble/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:10 with water (marble is calcareous!). Pre-wet the surface. Apply carefully, leave maximum 2-3 minutes. Rinse immediately and thoroughly with plenty of water. Repeat if needed rather than using stronger concentration.",
      tips: ["test_first", "dilute_calcareous", "rinse_thoroughly", "never_acid_marble"]
    },
    "natural-stone/marble/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:5 to 1:10 depending on soiling. Apply with mop or sponge. Leave 5-10 minutes. Scrub and rinse with clean water.",
      tips: ["daily_wash_clean", "never_acid_marble"]
    },
    "natural-stone/marble/limescale": {
      products: ["Lithofin MN Wash & Clean"],
      method: "Use MN Wash & Clean at double concentration. Apply with a soft cloth, leave briefly, wipe clean. Never use acidic limescale removers on marble!",
      tips: ["never_acid_marble", "no_vinegar_marble"]
    },
    "natural-stone/marble/mold-mildew": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:3 with warm water. Apply generously and leave 10-15 minutes. Scrub with a soft brush and rinse well. Improve ventilation to prevent recurrence.",
      tips: ["improve_ventilation", "never_acid_marble"]
    },
    "natural-stone/marble/oil-grease": {
      products: ["Lithofin OIL-EX"],
      method: "Apply a thick layer over the stain. Cover with cling film to prevent drying. Leave 2-12 hours (deeper stains need longer). Remove paste, clean with MN Wash & Clean.",
      tips: ["repeat_if_needed", "poultice_method"]
    },
    "natural-stone/marble/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:5 with water. Apply with sprayer or watering can. Leave 15-30 minutes. Scrub with soft brush and rinse thoroughly. Safe for calcareous stone.",
      tips: ["ideal_terrace", "outdoor_dry_weather", "never_acid_marble"]
    },
    "natural-stone/marble/rust-stains": {
      products: ["Lithofin Rust-EX"],
      method: "Apply undiluted onto the rust stain. Leave to act for 5-15 minutes. Rinse thoroughly with plenty of water. Repeat for stubborn stains.",
      tips: ["test_first", "never_acid_marble", "repeat_if_needed"]
    },
    "natural-stone/marble/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin MN Basic Protection", "Lithofin Stainstop PLUS", "Lithofin MN Care-Seal"],
      method: "Clean surface thoroughly and let dry completely. Apply Stain-Stop evenly with a cloth or brush. Remove excess after 10-15 minutes. Allow 24 hours to cure before use.",
      tips: ["max_protection", "remove_excess", "allow_to_dry"]
    },

    "natural-stone/sandstone/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3 or use undiluted for heavy growth. Apply with sprayer. Leave 30-60 minutes. Scrub with stiff brush, rinse thoroughly.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "natural-stone/sandstone/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface thoroughly first. Apply Anti-Slip evenly. Leave to act per instructions. Rinse thoroughly. Especially useful for outdoor sandstone paths and patios.",
      tips: ["anti_slip_wet_areas", "test_first", "sandstone_seal_essential"]
    },
    "natural-stone/sandstone/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Pre-wet thoroughly to limit absorption. Apply diluted 1:3 to 1:5. Leave 3-5 minutes. Scrub and rinse well.",
      tips: ["pre_wet_porous", "rinse_thoroughly"]
    },
    "natural-stone/sandstone/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Apply to clean, dry surface. Sandstone absorbs quickly - apply evenly in small sections. Remove excess promptly.",
      tips: ["wet_look", "work_in_sections"]
    },
    "natural-stone/sandstone/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water. Mop regularly. Ensure surface is properly sealed first for best results.",
      tips: ["sandstone_seal_essential"]
    },
    "natural-stone/sandstone/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Pre-wet surface. Apply diluted 1:5. Leave 3-5 minutes until salts dissolve. Rinse thoroughly. Repeat if needed.",
      tips: ["pre_wet_porous", "repeat_if_needed", "rinse_thoroughly"]
    },
    "natural-stone/sandstone/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:5 to 1:10. Pre-wet the surface. Apply, leave 5-10 minutes. Scrub with brush and rinse thoroughly.",
      tips: ["pre_wet_porous", "work_in_sections"]
    },
    "natural-stone/sandstone/limescale": {
      products: ["Lithofin MN Wash & Clean"],
      method: "Use MN Wash & Clean at double concentration. Apply with a soft cloth, leave briefly, wipe clean. Sandstone can tolerate mildly acidic products but always test first.",
      tips: ["test_first", "rinse_thoroughly"]
    },
    "natural-stone/sandstone/mold-mildew": {
      products: ["Lithofin ALGEX"],
      method: "Apply undiluted on affected areas. Leave 15-30 minutes. Scrub and rinse. Seal surface afterward to prevent recurrence.",
      tips: ["improve_ventilation", "sandstone_seal_essential"]
    },
    "natural-stone/sandstone/oil-grease": {
      products: ["Lithofin OIL-EX"],
      method: "Apply OIL-EX paste generously - sandstone absorbs deeply. Cover with film, leave 12-24 hours. Remove and clean. May need multiple applications.",
      tips: ["poultice_method", "repeat_if_needed"]
    },
    "natural-stone/sandstone/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:3 to 1:5. Apply with sprayer. Leave 15-30 minutes. Scrub and rinse with hose or pressure washer (low setting).",
      tips: ["ideal_terrace", "outdoor_dry_weather"]
    },
    "natural-stone/sandstone/rust-stains": {
      products: ["Lithofin Rust-EX"],
      method: "Apply undiluted onto the rust stain. Leave to act for 5-10 minutes maximum. Rinse thoroughly with plenty of water. Pre-wet surrounding area to limit product absorption.",
      tips: ["test_first", "pre_wet_porous", "rinse_thoroughly"]
    },
    "natural-stone/sandstone/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin MN Basic Protection", "Lithofin Stainstop PLUS", "Lithofin MN Care-Seal"],
      method: "Absolutely essential for sandstone! Apply generously to clean, dry surface. Two coats recommended due to high porosity. Remove excess after 15 minutes.",
      tips: ["sandstone_seal_essential", "two_coats_porous", "allow_to_dry"]
    },

    "natural-stone/slate/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3. Spray on, leave 30-60 minutes. Scrub and rinse. Treat preventively before the wet season.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "natural-stone/slate/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply Anti-Slip evenly. Leave to act per instructions. Rinse thoroughly.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "natural-stone/slate/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Apply diluted 1:3 to 1:5. Leave 3-5 minutes. Scrub gently following the natural grain. Rinse thoroughly.",
      tips: ["test_first", "rinse_thoroughly"]
    },
    "natural-stone/slate/color-enhancement": {
      products: ["Lithofin MN Slate-Oil"],
      method: "Apply Slate-Oil with a cloth or brush. Spread evenly and let it soak in. Buff lightly after 15-20 minutes. Brings out the natural beauty of slate.",
      tips: ["slate_oil_finish", "apply_evenly"]
    },
    "natural-stone/slate/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water. Mop regularly. Compatible with slate-oil treated surfaces.",
      tips: ["warm_water"]
    },
    "natural-stone/slate/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:5 with water. Pre-wet surface. Apply and leave 5 minutes. Scrub and rinse. Slate tolerates moderate acid concentrations.",
      tips: ["pre_wet_porous", "rinse_thoroughly"]
    },
    "natural-stone/slate/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:5 to 1:10. Apply with mop or sponge, leave 5 minutes. Scrub and rinse. Slate tolerates most alkaline cleaners well.",
      tips: ["work_in_sections"]
    },
    "natural-stone/slate/limescale": {
      products: ["Lithofin CEMENT-AWAY"],
      method: "Dilute 1:5 with water. Apply onto limescale deposits. Leave 3-5 minutes. Rinse thoroughly. Slate can handle mildly acidic products.",
      tips: ["test_first", "rinse_thoroughly"]
    },
    "natural-stone/slate/mold-mildew": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:3 with warm water. Apply and leave 10-15 minutes. Scrub with a brush and rinse well. Improve ventilation afterward.",
      tips: ["improve_ventilation", "test_first"]
    },
    "natural-stone/slate/oil-grease": {
      products: ["Lithofin OIL-EX"],
      method: "Apply OIL-EX paste over the stain. Cover with film. Leave 4-12 hours. Remove and clean with MN Wash & Clean.",
      tips: ["poultice_method", "repeat_if_needed"]
    },
    "natural-stone/slate/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:3 to 1:5. Apply, leave 15-30 minutes. Scrub with brush and rinse. Re-apply Slate-Oil after cleaning if desired.",
      tips: ["ideal_terrace", "slate_oil_finish"]
    },
    "natural-stone/slate/rust-stains": {
      products: ["Lithofin Rust-EX"],
      method: "Apply undiluted onto the rust stain. Leave to act for 5-15 minutes. Rinse thoroughly with plenty of water. Slate tolerates mild acid - safe to use.",
      tips: ["test_first", "repeat_if_needed"]
    },
    "natural-stone/slate/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin Stainstop PLUS", "Lithofin MN Care-Seal"],
      method: "Apply to clean, dry surface. Distribute evenly with a cloth. Remove excess after 10-15 minutes. Allow 24 hours to cure.",
      tips: ["invisible_protection", "remove_excess"]
    },

    // ── Ceramics & Tiles ──────────────────────────────────────
    "ceramics/ceramic/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply evenly, leave to act. Rinse thoroughly. Creates micro-texture without changing appearance.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "ceramics/ceramic/cement-residue": {
      products: ["Lithofin KF Cement Residue Remover"],
      method: "Apply undiluted on dry surface. Leave 5-10 minutes. Scrub and rinse. Safe for glazed and unglazed tiles.",
      tips: ["glazed_unglazed", "rinse_thoroughly"]
    },
    "ceramics/ceramic/daily-maintenance": {
      products: ["Lithofin KF Conditioning Cleaner", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water. Mop regularly. No rinsing needed.",
      tips: ["glazed_unglazed"]
    },
    "ceramics/ceramic/general-cleaning": {
      products: ["Lithofin KF Intensive Cleaner", "Lithofin KF Grout Cleaner"],
      method: "Dilute 1:5 to 1:10 depending on soiling. Apply, leave 5 minutes, scrub and rinse.",
      tips: ["work_in_sections"]
    },
    "ceramics/ceramic/limescale": {
      products: ["Lithofin KF Ceramic-Clean"],
      method: "Apply undiluted on limescale. Leave 3-5 minutes. Scrub and rinse thoroughly.",
      tips: ["bathroom_ideal"]
    },
    "ceramics/ceramic/mold-mildew": {
      products: ["Lithofin KF Mildew-Away"],
      method: "Spray on mold spots. Leave 10-15 minutes. Wipe clean. Especially effective in bathroom joints and corners.",
      tips: ["improve_ventilation", "bathroom_ideal"]
    },
    "ceramics/ceramic/oil-grease": {
      products: ["Lithofin KF Intensive Cleaner"],
      method: "Apply undiluted on grease stains. Leave 5-10 minutes. Scrub with pad and rinse.",
      tips: ["leave_to_act"]
    },
    "ceramics/ceramic/stain-protection": {
      products: ["Lithofin KF Protective Impregnator", "Lithofin Stainstop PLUS", "Lithofin KF Grout Protector"],
      method: "Apply to clean, dry unglazed tiles. Spread evenly, remove excess after 10 minutes. Glazed tiles generally don't need protection.",
      tips: ["remove_excess", "glazed_unglazed"]
    },

    "ceramics/glass-mosaic/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface thoroughly first. Apply Anti-Slip evenly on mosaic floor surfaces. Leave to act per instructions. Rinse thoroughly. Ideal for wet areas like showers.",
      tips: ["anti_slip_wet_areas", "test_first", "bathroom_ideal"]
    },
    "ceramics/glass-mosaic/cement-residue": {
      products: ["Lithofin KF Cement Residue Remover"],
      method: "Dilute 1:3 for glass mosaic! Apply carefully, leave 3-5 minutes max. Rinse thoroughly. Always test on an inconspicuous area first.",
      tips: ["glass_mosaic_gentle", "test_first", "rinse_thoroughly"]
    },
    "ceramics/glass-mosaic/daily-maintenance": {
      products: ["Lithofin KF Conditioning Cleaner", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water. Clean gently with soft mop or cloth.",
      tips: ["glass_mosaic_gentle"]
    },
    "ceramics/glass-mosaic/general-cleaning": {
      products: ["Lithofin KF Intensive Cleaner", "Lithofin KF Grout Cleaner"],
      method: "Dilute 1:10 for glass mosaic. Apply gently with soft cloth or sponge. Leave briefly, wipe and rinse.",
      tips: ["glass_mosaic_gentle", "test_first"]
    },
    "ceramics/glass-mosaic/limescale": {
      products: ["Lithofin KF Ceramic-Clean"],
      method: "Dilute 1:3 for glass mosaic. Apply on limescale, leave 2-3 minutes. Wipe clean with soft cloth. Rinse well.",
      tips: ["glass_mosaic_gentle", "bathroom_ideal"]
    },
    "ceramics/glass-mosaic/mold-mildew": {
      products: ["Lithofin KF Mildew-Away"],
      method: "Spray on affected grout joints. Leave 10-15 minutes. Wipe clean. Safe for glass mosaic.",
      tips: ["improve_ventilation", "bathroom_ideal"]
    },
    "ceramics/glass-mosaic/oil-grease": {
      products: ["Lithofin OIL-EX", "Lithofin KF Intensive Cleaner"],
      method: "For grease stains: apply OIL-EX paste, cover, leave 2-12 hours. For surface grease: use KF Intensive Cleaner diluted 1:3. Use gentle products on glass mosaic - always test on an inconspicuous area.",
      tips: ["poultice_method", "glass_mosaic_gentle", "test_first"]
    },
    "ceramics/glass-mosaic/stain-protection": {
      products: ["Lithofin KF Protective Impregnator", "Lithofin Stainstop PLUS", "Lithofin KF Grout Protector"],
      method: "Apply to clean, dry grout lines and unglazed mosaic parts. Spread evenly, remove excess after 10-15 minutes. Glass surfaces do not need protection - focus on grout and unglazed elements.",
      tips: ["remove_excess", "glass_mosaic_gentle"]
    },

    "ceramics/porcelain/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface thoroughly first. Apply Anti-Slip evenly. Leave to act per instructions. Rinse thoroughly. Ideal for shower floors.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "ceramics/porcelain/cement-residue": {
      products: ["Lithofin KF Cement Residue Remover"],
      method: "Apply undiluted on dry surface. Leave 5-10 minutes until residue dissolves. Scrub with pad and rinse thoroughly.",
      tips: ["glazed_unglazed", "rinse_thoroughly"]
    },
    "ceramics/porcelain/daily-maintenance": {
      products: ["Lithofin KF Conditioning Cleaner", "Lithofin EASY-CARE"],
      method: "Add 2 capfuls per bucket of warm water. Mop as usual. Cleans and cares in one step - no rinsing needed.",
      tips: ["glazed_unglazed", "warm_water"]
    },
    "ceramics/porcelain/general-cleaning": {
      products: ["Lithofin KF Intensive Cleaner", "Lithofin KF Grout Cleaner"],
      method: "Dilute 1:5 for regular deep cleaning. Apply, leave 5-10 minutes. Scrub with pad or machine, rinse well.",
      tips: ["work_in_sections", "leave_to_act"]
    },
    "ceramics/porcelain/limescale": {
      products: ["Lithofin KF Ceramic-Clean"],
      method: "Apply undiluted on limescale deposits. Leave 3-5 minutes. Scrub and rinse. Safe for all ceramic and porcelain surfaces.",
      tips: ["bathroom_ideal", "rinse_thoroughly"]
    },
    "ceramics/porcelain/mold-mildew": {
      products: ["Lithofin KF Mildew-Away"],
      method: "Spray directly on mold/mildew spots. Leave 10-15 minutes. Wipe clean and rinse. Chlorine-free formula.",
      tips: ["improve_ventilation", "bathroom_ideal"]
    },
    "ceramics/porcelain/oil-grease": {
      products: ["Lithofin OIL-EX", "Lithofin KF Intensive Cleaner"],
      method: "For grease stains: apply OIL-EX paste, cover, leave 2-12 hours. For surface grease: use KF Intensive Cleaner undiluted.",
      tips: ["poultice_method", "unglazed_porcelain"]
    },
    "ceramics/porcelain/stain-protection": {
      products: ["Lithofin KF Protective Impregnator", "Lithofin Stainstop PLUS", "Lithofin KF Grout Protector"],
      method: "Especially important for unglazed porcelain stoneware! Apply to clean, dry surface. Spread evenly, remove excess after 10 minutes.",
      tips: ["unglazed_porcelain", "remove_excess"]
    },

    // ── Artificial & Composite Stone ──────────────────────────────────────
    "artificial-stone/concrete/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3 or use undiluted for heavy growth. Spray on, leave 30-60 minutes. Scrub with stiff brush, rinse. Apply preventively in autumn.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "artificial-stone/concrete/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply evenly. Leave to act per instructions. Rinse. Ideal for concrete pool surrounds and walkways.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "artificial-stone/concrete/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Pre-wet surface. Apply diluted 1:3 to 1:5. Leave 5-10 minutes. Scrub with stiff brush and rinse thoroughly.",
      tips: ["pre_wet_porous", "rinse_thoroughly"]
    },
    "artificial-stone/concrete/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Apply to clean, dry concrete. Deepens the natural grey beautifully. Apply evenly, remove excess after 10-15 minutes.",
      tips: ["wet_look", "work_in_sections"]
    },
    "artificial-stone/concrete/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water. Mop regularly.",
      tips: ["warm_water"]
    },
    "artificial-stone/concrete/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Pre-wet surface. Apply diluted 1:3 on efflorescence. Leave 3-5 minutes until salts dissolve. Rinse thoroughly.",
      tips: ["pre_wet_porous", "rinse_thoroughly"]
    },
    "artificial-stone/concrete/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:5. Apply with mop or sprayer. Leave 5-10 minutes. Scrub and rinse well.",
      tips: ["work_in_sections", "leave_to_act"]
    },
    "artificial-stone/concrete/limescale": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:5. Apply on limescale deposits. Leave 3-5 minutes. Rinse thoroughly.",
      tips: ["rinse_thoroughly"]
    },
    "artificial-stone/concrete/mold-mildew": {
      products: ["Lithofin ALGEX"],
      method: "Apply undiluted on mold. Leave 15-30 minutes. Scrub and rinse. Also works preventively.",
      tips: ["improve_ventilation", "preventive_effect"]
    },
    "artificial-stone/concrete/oil-grease": {
      products: ["Lithofin OIL-EX", "Lithofin MN Power-Clean"],
      method: "For deep oil stains: apply OIL-EX paste, cover with film, leave 12-24 hours. For surface grease: Power-Clean undiluted.",
      tips: ["poultice_method", "repeat_if_needed"]
    },
    "artificial-stone/concrete/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:3 to 1:5. Apply with sprayer. Leave 15-30 minutes. Scrub and rinse with pressure washer.",
      tips: ["ideal_terrace", "outdoor_dry_weather"]
    },
    "artificial-stone/concrete/stain-protection": {
      products: ["Lithofin MN Concrete Coating", "Lithofin MN Stain-Stop", "Lithofin Stainstop PLUS"],
      method: "Concrete Coating: apply in 2 thin, even coats with roller. Allow 4 hours between coats. Full cure in 24 hours. Stain-Stop: invisible alternative.",
      tips: ["concrete_seal_new", "two_coats_porous", "allow_to_dry"]
    },

    "artificial-stone/quartz-composite/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3 with water. Spray onto affected areas. Leave 30-60 minutes. Scrub gently and rinse. ALGEX is pH-neutral - safe for quartz composite.",
      tips: ["quartz_ph_neutral", "preventive_effect", "outdoor_dry_weather"]
    },
    "artificial-stone/quartz-composite/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface first. Apply Anti-Slip evenly. Leave to act per instructions. Rinse thoroughly.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "artificial-stone/quartz-composite/cement-residue": {
      products: ["Lithofin KF Cement Residue Remover"],
      method: "Apply diluted 1:3 on dry surface. Leave 3-5 minutes. Wipe clean and rinse. Test first on quartz composite!",
      tips: ["quartz_ph_neutral", "test_first"]
    },
    "artificial-stone/quartz-composite/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Apply to clean, dry surface. Spread evenly with a cloth. Remove excess after 10-15 minutes. Deepens the colour of quartz composite surfaces. Test on an inconspicuous area first.",
      tips: ["quartz_ph_neutral", "test_first", "apply_evenly", "remove_excess"]
    },
    "artificial-stone/quartz-composite/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin MN Easy-Clean", "Lithofin EASY-CARE"],
      method: "MN Easy-Clean: ideal spray-and-wipe for quartz countertops. MN Wash & Clean: for floor mopping.",
      tips: ["quartz_ph_neutral"]
    },
    "artificial-stone/quartz-composite/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:10 with water. Pre-wet surface. Apply carefully and leave maximum 3 minutes. Rinse thoroughly. Use only pH-neutral to mildly alkaline products on quartz composite.",
      tips: ["quartz_ph_neutral", "test_first", "rinse_thoroughly"]
    },
    "artificial-stone/quartz-composite/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:10. Apply with soft cloth or sponge. Leave briefly, wipe and rinse. Avoid abrasive pads on polished quartz.",
      tips: ["quartz_ph_neutral"]
    },
    "artificial-stone/quartz-composite/limescale": {
      products: ["Lithofin KF Ceramic-Clean"],
      method: "Apply diluted 1:5. Leave briefly (2-3 minutes). Wipe and rinse. Quartz composites vary - always test first.",
      tips: ["quartz_ph_neutral", "test_first"]
    },
    "artificial-stone/quartz-composite/mold-mildew": {
      products: ["Lithofin ALGEX"],
      method: "Apply diluted 1:3 or undiluted on mold. Leave 15-30 minutes. Scrub and rinse. ALGEX is pH-neutral - safe for quartz composite. Also works preventively.",
      tips: ["quartz_ph_neutral", "improve_ventilation", "preventive_effect"]
    },
    "artificial-stone/quartz-composite/oil-grease": {
      products: ["Lithofin OIL-EX"],
      method: "Apply paste over stain. Cover with film. Leave 2-6 hours. Quartz is non-porous so stains are usually surface-only.",
      tips: ["poultice_method"]
    },
    "artificial-stone/quartz-composite/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:5 with water. Apply with sprayer or watering can. Leave 15-30 minutes. Scrub and rinse. Mild alkaline - suitable for quartz composite.",
      tips: ["quartz_ph_neutral", "ideal_terrace", "outdoor_dry_weather"]
    },
    "artificial-stone/quartz-composite/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin Stainstop PLUS"],
      method: "Mainly needed for honed (matte) quartz surfaces. Apply thinly, remove excess after 10 minutes. Polished quartz is usually non-porous enough.",
      tips: ["quartz_ph_neutral", "remove_excess"]
    },

    "artificial-stone/terrazzo/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3 with water. Spray generously. Leave 30-60 minutes. Scrub with brush and rinse. ALGEX is pH-neutral - safe for terrazzo.",
      tips: ["terrazzo_avoid_acid", "preventive_effect", "outdoor_dry_weather"]
    },
    "artificial-stone/terrazzo/anti-slip": {
      products: ["Lithofin Anti-Slip"],
      method: "Clean surface thoroughly first. Apply Anti-Slip evenly. Leave to act per instructions. Rinse thoroughly.",
      tips: ["anti_slip_wet_areas", "test_first"]
    },
    "artificial-stone/terrazzo/cement-residue": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:5 to 1:10 - terrazzo often contains marble chips! Pre-wet surface. Leave 2-3 minutes max. Rinse immediately.",
      tips: ["terrazzo_avoid_acid", "dilute_calcareous", "test_first"]
    },
    "artificial-stone/terrazzo/color-enhancement": {
      products: ["Lithofin MN Colour Intensifier"],
      method: "Apply thinly to bring out the colour of the stone chips in terrazzo. Remove excess after 10 minutes.",
      tips: ["wet_look", "remove_excess"]
    },
    "artificial-stone/terrazzo/daily-maintenance": {
      products: ["Lithofin MN Wash & Clean", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water. pH-neutral - safe for daily use on terrazzo floors.",
      tips: ["terrazzo_avoid_acid"]
    },
    "artificial-stone/terrazzo/efflorescence": {
      products: ["Lithofin MN Builders\' Clean"],
      method: "Dilute 1:10 with water (terrazzo contains marble chips - calcareous!). Pre-wet surface. Apply carefully, leave maximum 2-3 minutes. Rinse immediately.",
      tips: ["terrazzo_avoid_acid", "test_first", "rinse_thoroughly"]
    },
    "artificial-stone/terrazzo/general-cleaning": {
      products: ["Lithofin MN Power-Clean"],
      method: "Dilute 1:10. Apply with mop, leave 5 minutes. Scrub gently and rinse. Treat terrazzo like marble for safety.",
      tips: ["terrazzo_avoid_acid", "work_in_sections"]
    },
    "artificial-stone/terrazzo/limescale": {
      products: ["Lithofin MN Wash & Clean"],
      method: "Use MN Wash & Clean at double concentration. Apply with a soft cloth, leave briefly, wipe clean. Never use acidic limescale removers on terrazzo - treat it like marble.",
      tips: ["terrazzo_avoid_acid", "test_first"]
    },
    "artificial-stone/terrazzo/mold-mildew": {
      products: ["Lithofin ALGEX"],
      method: "Apply diluted 1:3 on mold. Leave 15-30 minutes. Scrub and rinse. ALGEX is pH-neutral - safe for terrazzo. Improve ventilation.",
      tips: ["terrazzo_avoid_acid", "improve_ventilation", "preventive_effect"]
    },
    "artificial-stone/terrazzo/oil-grease": {
      products: ["Lithofin OIL-EX"],
      method: "Apply paste over stain. Cover with film. Leave 4-12 hours. Remove and clean with MN Wash & Clean.",
      tips: ["poultice_method", "repeat_if_needed"]
    },
    "artificial-stone/terrazzo/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:5 with water. Apply with sprayer. Leave 15-30 minutes. Scrub gently and rinse. Mild alkaline - safe for terrazzo.",
      tips: ["terrazzo_avoid_acid", "ideal_terrace", "outdoor_dry_weather"]
    },
    "artificial-stone/terrazzo/stain-protection": {
      products: ["Lithofin MN Stain-Stop", "Lithofin Stainstop PLUS"],
      method: "Apply to clean, dry surface. Distribute evenly. Remove excess after 10-15 minutes. Allow 24 hours to cure.",
      tips: ["remove_excess", "allow_to_dry"]
    },

    // ── Cotto & Terracotta ──────────────────────────────────────
    "cotto-terracotta/clinker/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Apply undiluted or diluted 1:3. Leave 30-60 minutes. Scrub and rinse. Clinker terraces benefit from preventive treatment.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "cotto-terracotta/clinker/cement-residue": {
      products: ["Lithofin KF Cement Residue Remover"],
      method: "Apply undiluted on dry surface. Leave 5-10 minutes. Scrub with stiff brush. Rinse thoroughly.",
      tips: ["rinse_thoroughly"]
    },
    "cotto-terracotta/clinker/color-enhancement": {
      products: ["Lithofin KF Clinker Oil"],
      method: "Apply Clinker Oil evenly with a cloth. Brings out the warm, natural tones of clinker tiles. Buff when dry.",
      tips: ["clinker_oil_finish", "buff_when_dry"]
    },
    "cotto-terracotta/clinker/daily-maintenance": {
      products: ["Lithofin KF Conditioning Cleaner", "Lithofin EASY-CARE"],
      method: "2 capfuls per bucket of warm water. Mop regularly. No rinsing needed.",
      tips: ["warm_water"]
    },
    "cotto-terracotta/clinker/efflorescence": {
      products: ["Lithofin CEMENT-AWAY"],
      method: "Apply diluted 1:5 on efflorescence deposits. Leave 3-5 minutes. Scrub and rinse thoroughly.",
      tips: ["rinse_thoroughly"]
    },
    "cotto-terracotta/clinker/general-cleaning": {
      products: ["Lithofin KF Intensive Cleaner"],
      method: "Dilute 1:5. Apply, leave 5-10 minutes. Scrub and rinse. Clinker is fired at high temperature and very durable.",
      tips: ["work_in_sections", "leave_to_act"]
    },
    "cotto-terracotta/clinker/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:3 to 1:5. Apply with sprayer. Leave 15-30 minutes. Scrub with stiff brush and rinse.",
      tips: ["ideal_terrace", "outdoor_dry_weather"]
    },
    "cotto-terracotta/clinker/stain-protection": {
      products: ["Lithofin KF Protective Impregnator", "Lithofin Stainstop PLUS"],
      method: "Apply to clean, dry clinker. Distribute evenly. Remove excess after 10 minutes. One coat usually sufficient.",
      tips: ["remove_excess"]
    },
    "cotto-terracotta/clinker/wax-residue": {
      products: ["Lithofin WAX-OFF", "Lithofin TC Classic Wax"],
      method: "Apply WAX-OFF undiluted on old wax layers. Leave 10-15 minutes until wax softens. Scrub and remove all residue. After stripping, re-apply TC Classic Wax in thin layers for fresh protection.",
      tips: ["remove_old_wax", "builds_wax_layer"]
    },

    "cotto-terracotta/cotto/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3. Spray on affected areas. Leave 30-60 minutes. Scrub and rinse. Seal afterward with TC Impregnator to protect.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "cotto-terracotta/cotto/cement-residue": {
      products: ["Lithofin CEMENT-AWAY"],
      method: "Dilute 1:10 for cotto. Pre-wet thoroughly! Apply very briefly (1-2 minutes). Rinse immediately. Cotto is extremely porous and absorbent.",
      tips: ["pre_wet_porous", "test_first", "dilute_calcareous"]
    },
    "cotto-terracotta/cotto/color-enhancement": {
      products: ["Lithofin TC Classic Primer", "Lithofin TC Classic Wax"],
      method: "Apply TC Classic Primer first - stains the cotto to desired warmth. Once dry, apply TC Classic Wax. Buff when dry for a satin sheen.",
      tips: ["apply_evenly", "buff_when_dry"]
    },
    "cotto-terracotta/cotto/daily-maintenance": {
      products: ["Lithofin TC Sealant", "Lithofin EASY-CARE"],
      method: "Add to mop water for regular cleaning. Cleans gently while maintaining and building the wax layer over time.",
      tips: ["builds_wax_layer"]
    },
    "cotto-terracotta/cotto/general-cleaning": {
      products: ["Lithofin Cotto Easy-Clean"],
      method: "Dilute 1:5. Apply with mop, leave 5 minutes. Scrub and mop up. The dedicated cotto cleaner respects the wax layer.",
      tips: ["work_in_sections"]
    },
    "cotto-terracotta/cotto/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:5. Spray on, leave 15-30 minutes. Scrub with brush and rinse. Re-treat with TC Impregnator after cleaning.",
      tips: ["ideal_terrace", "outdoor_dry_weather"]
    },
    "cotto-terracotta/cotto/stain-protection": {
      products: ["Lithofin TC Impregnator", "Lithofin Stainstop PLUS"],
      method: "Essential for cotto! Apply generously on clean, dry tiles. Two coats recommended. Remove excess after 15 minutes. Allow 24 hours before waxing.",
      tips: ["two_coats_porous", "remove_excess", "allow_to_dry"]
    },
    "cotto-terracotta/cotto/wax-residue": {
      products: ["Lithofin WAX-OFF", "Lithofin WEXA"],
      method: "Apply WEXA undiluted on old wax. Leave 10-15 minutes. Scrub with pad to remove softened wax. Rinse well. Re-wax after stripping.",
      tips: ["remove_old_wax"]
    },

    "cotto-terracotta/terracotta/algae-moss": {
      products: ["Lithofin ALGEX"],
      method: "Dilute 1:3. Spray on affected areas. Leave 30-60 minutes. Scrub and rinse. Seal afterward with TC Impregnator.",
      tips: ["preventive_effect", "outdoor_dry_weather"]
    },
    "cotto-terracotta/terracotta/cement-residue": {
      products: ["Lithofin CEMENT-AWAY"],
      method: "Dilute 1:5 to 1:10 for terracotta. Pre-wet surface thoroughly. Apply, leave 2-3 minutes. Rinse immediately. Test first!",
      tips: ["pre_wet_porous", "test_first", "rinse_thoroughly"]
    },
    "cotto-terracotta/terracotta/color-enhancement": {
      products: ["Lithofin TC Classic Primer", "Lithofin TC Classic Wax"],
      method: "First apply TC Classic Primer to enhance the warm terracotta colour. When dry, apply TC Classic Wax for a beautiful satin finish.",
      tips: ["apply_evenly", "buff_when_dry"]
    },
    "cotto-terracotta/terracotta/daily-maintenance": {
      products: ["Lithofin TC Sealant", "Lithofin TC Ever-Sheen", "Lithofin EASY-CARE"],
      method: "TC Sealant: add to mop water for regular cleaning. Builds up a gentle protective layer over time. TC Ever-Sheen: spray on for quick shine.",
      tips: ["builds_wax_layer"]
    },
    "cotto-terracotta/terracotta/general-cleaning": {
      products: ["Lithofin Cotto Easy-Clean"],
      method: "Dilute 1:5 for regular cleaning. Apply with mop. Leave 5 minutes. Scrub and mop up dirty solution.",
      tips: ["work_in_sections"]
    },
    "cotto-terracotta/terracotta/outdoor-cleaning": {
      products: ["Lithofin MN Outdoor Cleaner"],
      method: "Dilute 1:5. Spray on, leave 15-30 minutes. Scrub with brush and rinse. Re-treat with TC Impregnator after cleaning.",
      tips: ["ideal_terrace", "outdoor_dry_weather"]
    },
    "cotto-terracotta/terracotta/stain-protection": {
      products: ["Lithofin TC Impregnator", "Lithofin Stainstop PLUS"],
      method: "Apply to clean, dry terracotta. Spread evenly with cloth or brush. Remove excess after 15 minutes. Apply two coats on very porous tiles.",
      tips: ["two_coats_porous", "remove_excess"]
    },
    "cotto-terracotta/terracotta/wax-residue": {
      products: ["Lithofin WAX-OFF", "Lithofin WEXA", "Lithofin TC Classic Wax"],
      method: "Apply WEXA undiluted on old wax layers. Leave 10-15 minutes until wax softens. Scrub and remove. After stripping, re-apply TC Classic Wax for fresh protection.",
      tips: ["remove_old_wax", "builds_wax_layer"]
    }
  }
};

